module.exports = __webpack_public_path__ + "static/media/wine-glass.9bd758f4.svg";